import { Box, BoxProps } from "@dropbox/dig-foundations";
import { SvgPurpleLine } from "./background/PurpleLine";

const DEFAULT_FILL_COLOR = "#E3D7F6";

export const UserProfileBackgroundImage = ({
  borderRadius = "Large",
  height = "128px",
}: {
  borderRadius?: BoxProps<"div">["borderRadius"];
  height?: string;
}) => {
  return (
    <Box
      borderRadius={borderRadius}
      style={{
        height,
        width: "100%",
        backgroundColor: DEFAULT_FILL_COLOR,
        flexShrink: 0,
      }}
    >
      <SvgPurpleLine />
    </Box>
  );
};
